import { AwaitContainer } from '@ibsys/kit';
import React from 'react';
import { BetaFeatureCode, useBetaFeatureState } from '@/entities/beta-feature';
import { NotFoundPage } from '@/pages/NotFoundPage';

export type BetaFeatureRouteProps = {
  betaFeature: BetaFeatureCode;
  children: React.ReactNode;
};

/**
 * Закрывает маршрут бета-функцией: пока она выключена, адрес отвечает как несуществующий —
 * раздел не выдаёт факта своего существования. Ожидание реестра неотличимо от выключенной
 * функции, поэтому до его получения показывается загрузка, а не «страница не найдена»:
 * иначе прямой заход на адрес раздела всегда упирался бы в неё.
 */
export const BetaFeatureRoute: React.FC<BetaFeatureRouteProps> = ({ betaFeature, children }) => {
  const { isEnabled, isResolved } = useBetaFeatureState(betaFeature);

  if (!isResolved) {
    return <AwaitContainer isLoading className="h-full" />;
  }

  if (!isEnabled) {
    return <NotFoundPage />;
  }

  return <>{children}</>;
};
